import {
  SEARCHABLE_VENDOR_TAXONOMY_KEYS,
  VENUES_TAXONOMY_KEY,
} from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { getVendorWordCategory } from '@zola-helpers/client/dist/es/marketplace/vendorWords';
import { USCityView } from '@zola/svc-marketplace-ts-types';
import {
  InlineAccordion,
  InlineAccordionItemType,
} from '@zola/zola-ui/src/components/InlineAccordion/InlineAccordion';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { Title2 } from '@zola/zola-ui/src/typography/Headings';

import { US_STATES } from '~/components/common/form/addresses';

import createCanonicalUrl from '../../util/canonicalUrl';
import { PageSection } from '../PageSection/PageSection';

import styles from './seoCrossLinksSection.module.less';

const getNearbyItem = (nearbyCities: USCityView[]): InlineAccordionItemType => {
  return {
    title: (
      <Title2 className={styles.title} presentation="h6">
        Venues in Nearby Cities
      </Title2>
    ),
    content: (
      <ul className={styles.list}>
        {nearbyCities.map((city, index) => {
          const canonicalUrl = createCanonicalUrl({
            selectedLocation: { slug: city.slug },
            selectedTaxonomy: { key: VENUES_TAXONOMY_KEY },
          });
          return (
            <li key={index}>
              <LinkV2 className={styles.link} href={canonicalUrl} noTextTransform subtle>
                Wedding Venues in {city.name}, {city.stateCode}
              </LinkV2>
            </li>
          );
        })}
      </ul>
    ),
  };
};

const getStateItems = () => {
  const items: InlineAccordionItemType[] = [];

  SEARCHABLE_VENDOR_TAXONOMY_KEYS.forEach((taxonomyKey) => {
    const category = getVendorWordCategory(taxonomyKey);
    items.push({
      title: (
        <Title2 className={styles.title} presentation="h6">
          {category} by State
        </Title2>
      ),
      content: (
        <ul className={styles.list} key={taxonomyKey}>
          {US_STATES.map((state, index) => {
            const canonicalUrl = createCanonicalUrl({
              selectedLocation: { slug: state.slug },
              selectedTaxonomy: { key: taxonomyKey },
            });
            return (
              <li key={index}>
                <LinkV2 className={styles.link} href={canonicalUrl} noTextTransform subtle>
                  Wedding {category} in {state.name}
                </LinkV2>
              </li>
            );
          })}
        </ul>
      ),
    });
  });

  return items;
};

interface SeoCrossLinksSectionProps {
  nearbyCities: USCityView[];
}

export const SeoCrossLinksSection = ({ nearbyCities }: SeoCrossLinksSectionProps) => {
  const items: InlineAccordionItemType[] = [];

  if (nearbyCities.length > 0) {
    items.push(getNearbyItem(nearbyCities));
  }

  items.push(...getStateItems());

  return (
    <PageSection contentClassName={styles.seoCrossLinksSection}>
      <InlineAccordion items={items} />
    </PageSection>
  );
};
